import { render } from "./News_index.vue?vue&type=template&id=13518c6e&scoped=true"
import script from "./News_index.vue?vue&type=script&lang=js"
export * from "./News_index.vue?vue&type=script&lang=js"

import "./News_index.vue?vue&type=style&index=0&id=13518c6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13518c6e"

export default script